import React from 'react';
import { useNavigate } from 'react-router-dom';

import PreviousSelectedAvatarView from './PreviousSelectedAvatarView';

import { useMytaverseEvent } from '@core/dashboard/providers';

import { useMytaverse } from '@providers/MytaverseProvider';
import { sendCustomSentryBreadcrumb } from '@helpers/sentry';

import ROUTES from '@constants/routes';

const PreviousSelectedAvatar = () => {
  const {
    currentEventId,
    previousSkin,
    selectSkin,
    previousCustomAvatar,
    setCurrentSkin,
    resetPreviousSkin,
    resetPreviousCustomSkin,
  } = useMytaverseEvent();

  const { customAvatarUrl, setCustomAvatarUrl } = useMytaverse();

  const navigate = useNavigate();

  const handleChangeAvatar = () => {
    sendCustomSentryBreadcrumb({ message: 'change avatar' });
    (previousSkin ? resetPreviousSkin : resetPreviousCustomSkin)();
  };

  const handleSelectAvatar = () => {
    if (previousSkin) {
      sendCustomSentryBreadcrumb({ message: 'go to select skin' });
      setCustomAvatarUrl(null);
      setCurrentSkin(previousSkin);
      selectSkin(previousSkin);
    } else {
      setCustomAvatarUrl(previousCustomAvatar);
    }

    navigate(ROUTES.DEVICES_TEST(currentEventId));
  };

  const handleSelectPrevAvatar = () => {
    sendCustomSentryBreadcrumb({ message: 'select previous avatar' });
    setCustomAvatarUrl(previousCustomAvatar);
    navigate(ROUTES.DEVICES_TEST(currentEventId));
  };

  return (
    <PreviousSelectedAvatarView
      previousSkin={previousSkin}
      customAvatarUrl={customAvatarUrl}
      onChangeAvatar={handleChangeAvatar}
      onSelectAvatar={handleSelectAvatar}
      onSelectPrevAvatar={handleSelectPrevAvatar}
    />
  );
};

export default PreviousSelectedAvatar;
